{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Izaberite razgovor sa leve strane",
    "CSAT_REPLY_MESSAGE": "Molim vas ocenite ovaj razgovor",
    "404": "Izvinite, ne možemo da pronađemo razgovor. Molim vas pokušajte ponovo",
    "SWITCH_VIEW_LAYOUT": "Promeni raspored",
    "DASHBOARD_APP_TAB_MESSAGES": "Poruke",
    "UNVERIFIED_SESSION": "Identitet korisnika nije potvrđen",
    "NO_MESSAGE_1": "O ne! Izgleda da nema poruka od korisnika u vašem prijemnom sandučetu.",
    "NO_MESSAGE_2": " poslati poruku tvojoj stranici!",
    "NO_INBOX_1": "Pozdrav! Izgleda da još uvek niste dodali prijemno sanduče.",
    "NO_INBOX_2": " da bi ste počeli",
    "NO_INBOX_AGENT": "O ne! Izgleda da niste deo nijednog prijemnog sandučeta. Molim vas kontaktirajte vašeg administratora",
    "SEARCH_MESSAGES": "Pretražite poruke u razgovorima",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Pretraži poruke",
      "RESULT_TITLE": "Rezultat pretrage",
      "LOADING_MESSAGE": "Obrada podataka...",
      "PLACEHOLDER": "Upišite bilo koji tekst da bi ste pretražili poruke",
      "NO_MATCHING_RESULTS": "Ništa nije pronađeno."
    },
    "UNREAD_MESSAGES": "Nepročitane poruke",
    "UNREAD_MESSAGE": "Nepročitana poruka",
    "CLICK_HERE": "Kliknite ovde",
    "LOADING_INBOXES": "Učitavanje prijemnih sandučića",
    "LOADING_CONVERSATIONS": "Učitavanje razgovora",
    "CANNOT_REPLY": "Ne možete da odgovorite zbog",
    "24_HOURS_WINDOW": "24-časovno ograničenje poruka",
    "48_HOURS_WINDOW": "48-časovno ograničenje poruka",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Ovaj razgovor nije dodeljen vama. Da li želite da dodelite razgovor sebi?",
    "ASSIGN_TO_ME": "Dodeli meni",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Možete jedino da odgovarate na ovaj razgovor koristeći šablon poruka zbog",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24-časovno ograničenje poruka",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "REPLYING_TO": "Odgovarate na:",
    "REMOVE_SELECTION": "Ukloni izbor",
    "DOWNLOAD": "Preuzmi",
    "UNKNOWN_FILE_TYPE": "Nepoznata datoteka",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file",
      "MEETING": "{sender} has started a meeting"
    },
    "UPLOADING_ATTACHMENTS": "Dodavanje priloga...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Poruka je uspešno obrisana",
    "FAIL_DELETE_MESSSAGE": "Nije bilo moguće obrisati poruku! Pokušajte ponovo",
    "NO_RESPONSE": "Nema odgovora",
    "RESPONSE": "Response",
    "RATING_TITLE": "Ocena",
    "FEEDBACK_TITLE": "Povratne informacije",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Reši",
      "REOPEN_ACTION": "Ponovo otvori",
      "OPEN_ACTION": "Otvoreni",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Više",
      "CLOSE": "Zatvori",
      "DETAILS": "detalji",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Odloženo do sutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Odloženo do sledeće nedelje",
      "SNOOZED_UNTIL_NEXT_REPLY": "Odloženo do sledećeg odgovora",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Označeno na čekanju",
      "SNOOZE_UNTIL": "Odloži",
      "SNOOZE": {
        "TITLE": "Odloži do",
        "NEXT_REPLY": "Sledećeg odgovora",
        "TOMORROW": "Sutra",
        "NEXT_WEEK": "Sledeće nedelje"
      }
    },
    "MENTION": {
      "AGENTS": "Agenti",
      "TEAMS": "Timovi"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Odloži do",
      "APPLY": "Odloži",
      "CANCEL": "Otkaži"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Niko",
        "URGENT": "Urgent",
        "HIGH": "High",
        "MEDIUM": "Medium",
        "LOW": "Low"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Niko",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Ništa nije pronađeno",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Izbriši"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Označeno na čekanju",
      "RESOLVED": "Označi kao rešeno",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Ponovo otvori razgovor",
      "SNOOZE": {
        "TITLE": "Odloži",
        "NEXT_REPLY": "Do sledećeg odgovora",
        "TOMORROW": "Do sutra",
        "NEXT_WEEK": "Do sledeće nedelje"
      },
      "ASSIGN_AGENT": "Dodeli agenta",
      "ASSIGN_LABEL": "Dodeli oznaku",
      "AGENTS_LOADING": "Učitavanje agenata...",
      "ASSIGN_TEAM": "Dodeli tim",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Razgovor sa ID {conversationId} je dodeljen \"{agentName}\"",
          "FAILED": "Nije bilo moguće dodeliti agenta. Molim vas pokušajte ponovo."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nije bilo moguće dodeliti oznaku. Molim vas pokušajte ponovo."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Dodeljen je tim \"{team}\" razgovoru sa id {conversationId}",
          "FAILED": "Nije bilo moguće dodeliti tim. Molim vas pokušajte ponovo."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Potpis poruke",
      "ENABLE_SIGN_TOOLTIP": "Omogući potpis",
      "DISABLE_SIGN_TOOLTIP": "Onemogući potpis",
      "MSG_INPUT": "Shift + enter za novi red. Počni sa '/' da bi ste izabrali brzi odgovor.",
      "PRIVATE_MSG_INPUT": "Shift + enter za novi red. Ovo će biti vidljivo samo agentima",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Potpis poruke nije podešen, molim vas podesite ga u podešavanjima profila.",
      "COPILOT_MSG_INPUT": "Dajte copilotu dodatne zahteve, ili pitajte bilo šta drugo... Pritisnite enter za slanje dopune",
      "CLICK_HERE": "Kliknite ovde da izmenite",
      "WHATSAPP_TEMPLATES": "Whatsapp šabloni"
    },
    "REPLYBOX": {
      "REPLY": "Odgovor",
      "PRIVATE_NOTE": "Privatna beleška",
      "SEND": "Pošalji",
      "CREATE": "Dodaj belešku",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_EMOJI_ICON": "Prikaži birač emotikona",
      "TIP_ATTACH_ICON": "Dodaj datoteke",
      "TIP_AUDIORECORDER_ICON": "Snimi zvuk",
      "TIP_AUDIORECORDER_PERMISSION": "Dozvoli pristup zvuku",
      "TIP_AUDIORECORDER_ERROR": "Nije moguće pristupiti zvuku",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Prevuci i pusti za dodavanje",
      "START_AUDIO_RECORDING": "Pokreni snimanje zvuka",
      "STOP_AUDIO_RECORDING": "Zaustavi snimanje zvuka",
      "COPILOT_THINKING": "Copilot razmišlja",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Dodaj bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-pošte odvojene zarezima",
          "ERROR": "Molim vas unesite ispravne adrese e-pošte"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "E-pošte odvojene zarezima",
          "ERROR": "Molim vas unesite ispravne adrese e-pošte"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Pošalji",
          "CANCEL": "Otkaži"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Privatna beleška: Vidljiva samo vama i vašem timu",
    "CHANGE_STATUS": "Status razgovora je izmenjen",
    "CHANGE_STATUS_FAILED": "Nije uspela izmena statusa razgovora",
    "CHANGE_AGENT": "Izmenjen je dodeljen razgovoru",
    "CHANGE_AGENT_FAILED": "Nije uspela izmena dodeljenog",
    "ASSIGN_LABEL_SUCCESFUL": "Oznaka je uspešno dodeljena",
    "ASSIGN_LABEL_FAILED": "Nije uspela dodela oznake",
    "CHANGE_TEAM": "Tim razgovora je promenjen",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "File exceeds the {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB attachment limit",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Nije moguće slanje poruke, molim vas pokušajte ponovo",
    "SENT_BY": "Poslao:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Nije bilo moguće poslati poruku! Pokušajte ponovo",
    "TRY_AGAIN": "pokušaj ponovo",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Izaberi agenta",
      "REMOVE": "Ukloni",
      "ASSIGN": "Dodeli"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiraj",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Izbriši",
      "CREATE_A_CANNED_RESPONSE": "Add to canned responses",
      "TRANSLATE": "Prevedi",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Izbriši",
        "CANCEL": "Otkaži"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Dismiss",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Pošalji transkript razgovora",
    "DESC": "Pošaljite kopiju transkripta razgovora na određenu adresu e-pošte",
    "SUBMIT": "Pošalji",
    "CANCEL": "Otkaži",
    "SEND_EMAIL_SUCCESS": "Transkript razgovora je uspešno poslat",
    "SEND_EMAIL_ERROR": "Pojavila se greška, molim vas pokušajte ponovo",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Pošaljite transkript potrošaču",
      "SEND_TO_AGENT": "Pošaljite transkript dodeljenom agentu",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Pošaljite transkript još jednoj adresi e-pošte",
      "EMAIL": {
        "PLACEHOLDER": "Unesite adresu e-pošte",
        "ERROR": "Molim vas unesite ispravnu adresu e-pošte"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Zdravo 👋, Dobrodošli u {installationName}!",
    "DESCRIPTION": "Hvala vam na registraciji. Želimo da najbolje iskoristite ovu {installationName}. Evo nekoliko stvari koje možete da uradite u {installationName} da bi vaše iskustvo bilo izvrsno.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Pročitajte naše najnovije izmene",
    "ALL_CONVERSATION": {
      "TITLE": "Svi vaši razgovori na jednom mestu",
      "DESCRIPTION": "Pregledajte sve razgovore sa vašim kupcima u jednoj radnoj tabli. Možete filtrirati razgovore prema dolaznom kanalu, oznaci i statusu.",
      "NEW_LINK": "Kliknite ovde da napravite prijemno sanduče"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Pozovite članove vašeg tima",
      "DESCRIPTION": "Sobzirom da se spremate da razgovarate sa vašim potrošačima, dovedite članove vašeg time da vam pomognu. Možete pozvati članove vašeg time dodavanjem njihove adrese e-pošte u spisak agenata.",
      "NEW_LINK": "Kliknite ovde da pozovete člana tima"
    },
    "LABELS": {
      "TITLE": "Organizujte razgovore sa oznakama",
      "DESCRIPTION": "Oznake omogućavaju lakši način da se kategorišu razgovori. Napravite oznake poput #upit-podrske, #pitanje-placanja itd., kako bi ste ih koristili u kasnijim razgovorima.",
      "NEW_LINK": "Kliknite ovde da napravite oznake"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Dodeljeni agent",
    "SELF_ASSIGN": "Dodeli meni",
    "TEAM_LABEL": "Dodeljeni tim",
    "SELECT": {
      "PLACEHOLDER": "Niko"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Detalji o kontaktu",
      "CONVERSATION_ACTIONS": "Akcije nad razgovorom",
      "CONVERSATION_LABELS": "Oznake razgovora",
      "CONVERSATION_INFO": "Informacije o razgovoru",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Atributi kontakta",
      "PREVIOUS_CONVERSATION": "Prethodni razgovor",
      "MACROS": "Macros",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "View all",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Nerešen",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Napravi atribut",
    "NO_RECORDS_FOUND": "Nijedan atribut nije pronađen",
    "UPDATE": {
      "SUCCESS": "Atribut je uspešno izmenjen",
      "ERROR": "Nije bilo moguće izmeniti atribut. Molim vas pokušajte ponovo"
    },
    "ADD": {
      "TITLE": "Dodaj",
      "SUCCESS": "Atribut je uspešno dodat",
      "ERROR": "Nije bilo moguće dodati atribut. Molim vas pokušajte ponovo"
    },
    "DELETE": {
      "SUCCESS": "Atribut je uspešno obrisan",
      "ERROR": "Nije bilo moguće obrisati atribut. Molim vas pokušajte ponovo"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Dodaj atribute",
      "PLACEHOLDER": "Traži atribute",
      "NO_RESULT": "Nijedan atribut nije pronađen"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Za",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Naslov",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Ništa nije pronađeno",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
